<template>
  <ZccScheduleList
    :yesterday="dataYesterday"
    :loadingYesterday="isLoadingDashboardYesterday"
    :hideOldSchedulesYesterday="hideOldSchedulesYesterday"
    @update:hideOldSchedulesYesterday="refetchYesterday"
    :today="dataToday"
    :loadingToday="isLoadingDashboardToday"
    :hideOldSchedulesToday="hideOldSchedulesToday"
    @update:hideOldSchedulesToday="refetchToday"
  ></ZccScheduleList>
</template>

<script lang="ts" setup>
import { useGetDashboard } from '@planbord/queries/planbord-api';
import { ZccScheduleList } from '@planbord/ui/components';
import { onMounted } from 'vue';

function refetchYesterday(value: unknown) {
  hideOldSchedulesYesterday.value = value;
}

function refetchToday(value: unknown) {
  hideOldSchedulesToday.value = value;
}

const {
  datetime: yesterday,
  data: dataYesterday,
  hideOldSchedules: hideOldSchedulesYesterday,
  isLoading: isLoadingDashboardYesterday,
} = useGetDashboard();

const {
  datetime: today,
  data: dataToday,
  hideOldSchedules: hideOldSchedulesToday,
  isLoading: isLoadingDashboardToday,
} = useGetDashboard();

function setDateTime() {
  //today
  today.value = new Date().toISOString().split('T')[0];

  //yesterday date object
  const date = new Date();
  date.setDate(date.getDate() - 1);

  yesterday.value = date.toISOString().split('T')[0];
}

function setHideOldSchedules() {
  //default when loading (maybe get from localstorage???)
  hideOldSchedulesToday.value = true;
  hideOldSchedulesYesterday.value = true;
}

onMounted(() => {
  setDateTime();
  setHideOldSchedules();
});
</script>
